import { ETechnologiesValues, TTechnologiesValues } from '@enums/common';

const TECH_PATTERNS = {
	T_5G: '5G',
	T_4G_TDD: '4G_TDD',
	T_4G_FDD: '4G_FDD',
} as const;

export const getMarkerTechType = (
	arrayOfTechs: string[],
	enabledTechnologies?: TTechnologiesValues[] | null,
): TTechnologiesValues | undefined => {
	if (!Array.isArray(arrayOfTechs) || arrayOfTechs.length === 0) return;

	const availableTechnologies = enabledTechnologies && enabledTechnologies.length > 0
		? arrayOfTechs.filter(tech => {
			if (tech.includes(TECH_PATTERNS.T_5G)) {
				return enabledTechnologies.includes(ETechnologiesValues.T_5G);
			}
			if (tech.includes(TECH_PATTERNS.T_4G_TDD)) {
				return enabledTechnologies.includes(ETechnologiesValues.T_4G_TDD);
			}
			if (tech.includes(TECH_PATTERNS.T_4G_FDD)) {
				return enabledTechnologies.includes(ETechnologiesValues.T_4G_FDD);
			}

			return false;
		})
		: arrayOfTechs;

	if (availableTechnologies.some((tech) => tech.includes(TECH_PATTERNS.T_5G))) {
		return ETechnologiesValues.T_5G;
	}

	if (availableTechnologies.some((tech) => tech.includes(TECH_PATTERNS.T_4G_TDD))) {
		return ETechnologiesValues.T_4G_TDD;
	}

	if (availableTechnologies.some((tech) => tech.includes(TECH_PATTERNS.T_4G_FDD))) {
		return ETechnologiesValues.T_4G_FDD;
	}
};
